import React, { useContext, useEffect, useState } from "react";
import styles from "./RulesBoxDescription.module.css";
import closebutton from "../../assests/closebutton.svg";
import ReactPlayer from "react-player";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";
import { useNavigate } from "react-router";
import Insta from "../../assests/instagram.png";
import fbLogo from "../../assests/share/fbLogo.svg";
import twitterLogo from "../../assests/share/twitter.svg";
import { isEmpty } from "lodash";
import PopupWrapper from "../../Layout/PopupWrapper";

export default function RulesBoxDescription({ setPopup, children, heading }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { details } = useContext(Context);
  const navigate = useNavigate();

  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };
  return (
    <PopupWrapper>
      <div className={styles.popupWrapper}>
        <div
          className={`h-full w-full bg-black bg-opacity-40 max-w-[425px] mx-auto pt-[50px] backdrop-blur-sm transform transition-transform ease-in-out duration-300
      ${show ? "translate-y-0" : "translate-y-full"}
      `}
        >
          {" "}
          <div className={`no-scrollbar ${styles.parentDiv}`}>
            <div className="flex justify-between items-center w-[100%] sticky top-0 left-0 bg-black ">
              <p className="text-large-bold p-[20px]">{heading}</p>
              <img
                src={closebutton}
                onClick={() => setPopup(false)}
                className=" hover:cursor-pointer p-[20px]"
              />
            </div>
            <div className="px-[20px]">{children}</div>
            <div className="seperator mt-[30px]" />
            <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
          </div>
        </div>
      </div>
    </PopupWrapper>
  );
}
